import { styled } from '@mui/material/styles';

export const ModuleWrapper = styled('div')`
  width: 100%;
`;
